import { FC, SVGProps } from "react";

const TopupMenuIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="5" y="2" width="10" height="20" rx="2" />
      <line x1="8" y1="5" x2="12" y2="5" />
      <circle cx="10" cy="18.5" r="0.5" />

      <line x1="8" y1="14" x2="8" y2="11" />
      <line x1="10" y1="14" x2="10" y2="9" />
      <line x1="12" y1="14" x2="12" y2="7" />

      <circle cx="18" cy="8" r="3" />
      <line x1="18" y1="6.8" x2="18" y2="9.2" />
      <line x1="16.8" y1="8" x2="19.2" y2="8" />
    </svg>
  );
};

export default TopupMenuIcon;
